module.exports = __webpack_public_path__ + "static/media/Topic_Icons2_PeopleBox.01fa7700.png";